import React, { ChangeEvent, useEffect, useState } from 'react';

import '../assets/scss/profile.scss';
import UserStore from '../store/UserStore';
import Header from '../components/common/Header';
import RatingStore from '../store/RatingStore';
import { observer } from 'mobx-react';
import { formatTime, numWord } from '../utils/utils';
import { runInAction } from 'mobx';

import '../assets/scss/settings.scss';
import '../assets/scss/react-datapicker.scss';
import DatePicker from 'react-datepicker';
import SettingsStore from '../store/SettingsStore';
import { useNavigate } from 'react-router-dom';

const formatDate = (date: string | undefined): Date => {
  if (date) {
    const parts = date.split('.');

    return new Date(`${parts[2]}-${parts[0]}-${parts[1]}`);
  }
  
  return new Date();
};

const saveDate = (date: Date | null) => {
  try {
    if (date === null) {
      SettingsStore.birthday = undefined;
      return;
    }
  
    const dateParts = date.toISOString().split('T')[0].split('-');
    dateParts[2] = (Number(dateParts[2]) + 1).toString();
  
    if (SettingsStore.birthday === `${dateParts[2]}.${dateParts[0]}.${dateParts[1]}`)
      return;
    
    SettingsStore.birthday =  `${dateParts[2]}.${dateParts[0]}.${dateParts[1]}`;
  } catch (e) {
    
  }
};

const SettingsPage: React.FC = observer(() => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [fetched, setFetched] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!fetched) {
      UserStore.getUserData();

      SettingsStore.photo = UserStore.photo;
      SettingsStore.nickName = UserStore.nickName;
      SettingsStore.firstName = UserStore.firstName;
      SettingsStore.lastName = UserStore.lastName;
      SettingsStore.email = UserStore.email;
      SettingsStore.sex = UserStore.sex;
      SettingsStore.birthday = UserStore.birthday;

      setFetched(true);
    }
  }, [fetched, setFetched]);

  var loadFile = function(event: ChangeEvent<HTMLInputElement>) {
    var image = document.getElementById('photo') as HTMLImageElement;
    if (event.currentTarget.files && event.currentTarget.files.length > 0) {
      image.style.background = `url(${URL.createObjectURL(event.currentTarget.files[0])})`;
      image.style.backgroundSize = 'cover';
      image.style.backgroundPosition = 'center';
    }
  };

  function a() {
    const elements = document.getElementsByClassName('react-datepicker__current-month') as HTMLCollectionOf<HTMLElement>;

    if (elements.length > 0) {
      const element = elements[0];
      const parts = element.innerText.split(' ');
      let month = parts[0];
      
      switch (month) {
        case 'January':
          month = 'Январь';
          break;
        case 'February':
          month = 'Февраль';
          break;
        case 'March':
          month = 'Март';
          break;
        case 'April':
          month = 'Апрель';
          break;
        case 'May':
          month = 'Май';
          break;
        case 'June':
          month = 'Июнь';
          break;
        case 'July':
          month = 'Июль';
          break;
        case 'August':
          month = 'Август';
          break;
        case 'September':
          month = 'Сентябрь';
          break;
        case 'October':
          month = 'Октябрь';
          break;
        case 'November':
          month = 'Ноябрь';
          break;
        case 'December':
          month = 'Декабрь';
          break;
      }

      element.innerText = `${month} ${parts[1]}`;
    }
  }
  
  return (
    <>
      <Header />
      <div className='sr__settings'>
        <div className='container'>
          <div className='sr__settings__inner'>
          <input type="file" accept="image/.jpeg,.jpg" name="photoFile" id="photoFile" onChange={loadFile} style={{ display: 'none' }} />
          <label htmlFor="photoFile" className='sr__settings__photoPicker'>
            <div
              className='sr__settings__photo'
              id="photo"
              style={{
                backgroundImage: SettingsStore.photo ? `url('https://scoreflect.ru/static/${SettingsStore.photo}')` : '',
                backgroundSize: SettingsStore.photo ? 'cover' : '',
                backgroundPosition: SettingsStore.photo ? 'center' : ''
              }}
            />
          </label>
          <div className='sr__settings__input'>
            <input
              className='sr__settings__textField'
              inputMode='text'
              name='nickName'
              autoComplete='nickName'
              placeholder='Никнейм'
              type='text'
              defaultValue={SettingsStore.nickName}
              onChange={SettingsStore.onChangeNickName}
            />
          </div>
          <div className='sr__settings__input'>
            <input
              className='sr__settings__textField'
              inputMode='text'
              name='firstName'
              autoComplete='firstName'
              placeholder='Имя'
              type='text'
              defaultValue={SettingsStore.firstName}
              onChange={SettingsStore.onChangeFirstName}
            />
          </div>
          <div className='sr__settings__input'>
            <input
              className='sr__settings__textField'
              inputMode='text'
              name='lastName'
              autoComplete='lastName'
              placeholder='Фамилия'
              type='text'
              defaultValue={SettingsStore.lastName}
              onChange={SettingsStore.onChangeLastName}
            />
          </div>
          {/*<div className='sr__settings__input'>
            <input
              className='sr__settings__textField'
              inputMode='email'
              name='email'
              autoComplete='email'
              placeholder='E-mail'
              type='email'
              defaultValue={SettingsStore.email}
              onChange={SettingsStore.onChangeEmail}
            />
          </div>*/}
          <div className='sr__settings__input--radio'>
            <label htmlFor="sex" className='sr__settings__radioField--label' onClick={() => SettingsStore.sex = 1}>
              <input
                className='sr__settings__radioField'
                id='male'
                inputMode='email'
                name='sex'
                autoComplete='sex'
                type='radio'
                checked={SettingsStore.sex === 1}
                onChange={() => SettingsStore.sex = 1}
              />
              Мужской
            </label>
            <label htmlFor="sex" className='sr__settings__radioField--label' onClick={() => SettingsStore.sex = 2}>
              <input
                className='sr__settings__radioField'
                id='female'
                inputMode='email'
                name='sex'
                autoComplete='sex'
                type='radio'
                checked={SettingsStore.sex === 2}
                onChange={() => SettingsStore.sex = 2}
              />
              Женский
            </label>
            <label htmlFor="sex" className='sr__settings__radioField--label' onClick={() => SettingsStore.sex = undefined}>
              <input
                className='sr__settings__radioField'
                id='not_specified'
                name='sex'
                autoComplete='sex'
                type='radio'
                checked={SettingsStore.sex === undefined}
                onChange={() => SettingsStore.sex = undefined}
              />
              Не указан
            </label>
            </div>
            {/*<div className='sr__settings__input'>
              <DatePicker
                dateFormat="dd.MM.yyyy"
                selected={formatDate(SettingsStore.birthday)}
                onChange={(date) => {a(); saveDate(date);}}
                onInputClick={() => a()}
                onMonthChange={() => a()}
                onCalendarOpen={() => a()}
                className='sr__settings__datePicker'
              />
            </div>*/}
            <button
              className='sr__settings__button'
              onClick={() => SettingsStore.update(navigate)}
            >Сохранить</button>
          </div>
        </div>
      </div>
    </>
  );
});

export default SettingsPage;